
import { AnalyticsData } from '../../dataTypes/types';
import { defineComponent, PropType } from 'vue';
export default defineComponent({
  props: {
    items: {
      type: Array as PropType<AnalyticsData[]>,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
});
